import { render } from "./userTariff.vue?vue&type=template&id=cb508124&scoped=true"
import script from "./userTariff.vue?vue&type=script&lang=js"
export * from "./userTariff.vue?vue&type=script&lang=js"

import "./userTariff.vue?vue&type=style&index=0&id=cb508124&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb508124"]])

export default __exports__